import React from 'react';

import type { ButtonProps } from 'src/shared/components/Button';
import { Button } from 'src/shared/components/Button';

const BaseCTAButton = ({
  isDisabled = false,
  isLoading = false,
  primaryCallToAction = true,
  fill = 'solid',
  ...props
}: ButtonProps) => (
  <Button
    fill={fill}
    fontSize={300}
    fontWeight={700}
    height={400}
    isDisabled={isDisabled}
    isLoading={isLoading}
    primaryCallToAction={primaryCallToAction}
    shape="box"
    width="100%"
    {...props}
  />
);

export { BaseCTAButton };
